import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { OperatorAuthProvider } from './context/OperatorAuthContext';
import App from './App';
import './styles.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <OperatorAuthProvider>
        <App />
      </OperatorAuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
